import type { MenuContainerRefs } from './types'
import { getPageFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'menuContainer'
const menuContainerRefProvider = getPageFeatureBoundRefProvider(featureName)

const menuContainerRefs: MenuContainerRefs = {
	isOpen: (menuContainerId) => menuContainerRefProvider([menuContainerId, 'isOpen']),
	isVisible: (menuContainerId) => menuContainerRefProvider([menuContainerId, 'isVisible']),
	toggle: (menuContainerId) => menuContainerRefProvider([menuContainerId, 'toggle']),
	open: (menuContainerId) => menuContainerRefProvider([menuContainerId, 'open']),
	close: (menuContainerId) => menuContainerRefProvider([menuContainerId, 'close']),
	animate: (menuContainerId) => menuContainerRefProvider([menuContainerId, 'animate']),
	getMenuContainerApiByChildId: () => menuContainerRefProvider(['getMenuContainerApiByChildId']),
}
export { menuContainerRefs }
